import { z } from 'zod';
import { ChannelIdSchema, TrackIdSchema } from './ids.js';
import { ColourSchema, TitleArtistSchema } from './party.js';
import { SpotifyTrackIdSchema, SpotifyTrackRefSchema } from './spotify.js';
import { PollSyncSchema } from './sync.js';
// No genre: Spotify doesn't publish one for a track.
// Everything but id/title/artist/artUrl is server-computed — only the server knows what this party
// has already been sent, played, or has on a deck right now.
// The three flags carry the same meanings they do on a CrowdWant, and are answered the same way:
// live, by title, against every channel's current queue and playback. A searcher is choosing what
// to send, so they are worth knowing before the send, not only after.
export const SearchResultTrackSchema = TitleArtistSchema.extend({
    id: SpotifyTrackIdSchema,
    artUrl: z.url().nullable(),
    isAlreadySuggested: z.boolean(),
    suggestedCount: z.number().int().min(0),
    playedBefore: z.boolean(),
    clashChannelId: ChannelIdSchema.nullable(),
    playingNowChannelId: ChannelIdSchema.nullable(),
}).readonly();
export const SEARCH_QUERY_MAX_LENGTH = 200;
// 10: the client-credentials grant 400s above 10 here, despite /v1/search's documented ceiling of 50 — verified against the live API.
export const SEARCH_RESULT_LIMIT = 10;
export const SearchQuerySchema = z
    .strictObject({
    q: z.string().trim().max(SEARCH_QUERY_MAX_LENGTH).optional(),
})
    .readonly();
export const SearchResultsSchema = z
    .strictObject({
    items: z.array(SearchResultTrackSchema).readonly(),
})
    .readonly();
export const QueuePreviewItemSchema = TitleArtistSchema.extend({
    id: TrackIdSchema,
    channelId: ChannelIdSchema,
    channelColour: ColourSchema,
    eta: z.string().min(1).max(32),
}).readonly();
export const ChannelChipSchema = z
    .strictObject({
    channelId: ChannelIdSchema,
    label: z.string().min(1),
    colour: ColourSchema,
    connected: z.boolean(),
})
    .readonly();
export const SuggesterViewSchema = z
    .strictObject({
    partyDisplayName: z.string().min(1),
    chips: z.array(ChannelChipSchema).readonly(),
    preview: z.array(QueuePreviewItemSchema).readonly(),
    sync: PollSyncSchema,
})
    .readonly();
// One field, not two: an id from search and a pasted link name the same track, so both reduce to the same id.
export const SuggestRequestSchema = z
    .strictObject({
    track: SpotifyTrackRefSchema,
})
    .readonly();
export const SuggestAckSchema = TitleArtistSchema.readonly();
//# sourceMappingURL=suggester.js.map